import React from 'react';
import { connect } from 'react-redux';
import {
    Modal,
} from 'react-bootstrap';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { ToastContainer, toast } from 'react-toastify';
import * as SVGICONS from '../../images/img/images';
// import * as signinActions from '../../actions/signinActions';
import * as appointmentActions from '../../actions/appointmentActions';
import * as specialistActions from '../../actions/specialistActions';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import './BlockAvailability.css'
import { blockingTimeArray, blockingMonth, DAYS, DAYSOFMONTH, generateUTCStartEndTiming } from './timeSLot';
var todayDate = moment.utc(new Date());
var convertDate = new Date(moment(todayDate).local());
class BlockD extends React.Component {
    constructor(props, context) {
        super(props, context);

        var currenthour = moment(todayDate).local().format("HH")
        var currentmin = moment(todayDate).local().format("mm")
        this.state = {
            initialblockingTimeArray: [],
            finalTimeSlot: blockingTimeArray,
            finalTimeSlotReset: blockingTimeArray,
            finalEndTimeSlot: blockingTimeArray,
            appointmentDate: convertDate,
            selectedAppointmentDate: Date,
            currenthour: currenthour,
            currentmin: currentmin,
            fetchSpecialistData: false,
            appointmentDatesGetched: false,
            isLoading: true,
            DAYSOFMONTH,
            specialistDetail: [],
            blockingDate: new Date(),
            startTime: blockingTimeArray[0],
            endTime: blockingTimeArray[1],
            reasonForBlocking: [],
            finalBlockingObj: {
                startDate: null,
                endDate: null,
                reason: "Third Party Appointment",
                noOfRecursion: 20,
                startTime: null,
                endTime: null,
                // daysBlocked: [
                //     'tuesday', 'wednesday', 'friday'
                // ],
            },
            daysBlocked: [],
            selectedPeriod: "daily",
            selectedDailyPeriodOption: "dailyNoEndDate",
            selectedMonthlyPeriodOption: "monthlyNoEndDate",
            selectedYearlyPeriodOption: 'yearlyNoEndDate',
            selectedWeeklyPeriodOption: 'weeklyNoEndDate',
            dateToBlock: convertDate.getDate(),
            //  DAYSOFMONTH[convertDate.getDate()],
            monthToBlock: convertDate.getMonth(),
            daily: {
                // endBy: new Date(),
                dailyEndByDate: convertDate,
                dailyOccurrence: 0,
            },
            monthly: {
                // endBy: new Date(),
                monthlyEndByDate: convertDate,
                monthlyOccurrence: 0,
            },
            yearly: {
                // endBy: new Date(),
                yearlyEndByDate: convertDate,
                yearlyOccurrence: 0,
            },
            weekly: {
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                friday: false,
                saturday: false,
                // endBy: new Date(),
                weeklyEndByDate: convertDate,
                weeklyOccurrence: 0,
            },
            selectedMonthForYearlyBlock: blockingMonth[convertDate.getMonth()],
        };
    }

    componentWillMount() {
        if (this.props.editTabClicked) {
            let { startTime, endTime, occurrence, startDate }= this.props.editProps;
            
            if(occurrence == 'dailyBlockAvailability')
            this.setState({
                selectedPeriod: 'daily'
            })
            if(occurrence == 'weeklyBlockAvailability')
            this.setState({
                selectedPeriod: 'weekly'
            })
            if(occurrence == 'monthlyBlockAvailability')
            this.setState({
                selectedPeriod: 'monthly'
            })
            if(occurrence == 'yearlyBlockAvailability')
            this.setState({
                selectedPeriod: 'yearly'
            })
            this.setState({
                DAYSOFMONTH,
                reasonForBlocking: this.props.reason,
                startTime,
                endTime,
                blockingDate: startDate
                // finalBlockingObj: {
                //     ...this.state.finalBlockingObj,
                //     startDate
                // }
            })
            
        }else{
            this.setState({ DAYSOFMONTH, reasonForBlocking: this.props.reason })

        }
        // 
        // let userToken = localStorage.getItem('token');
        // let specialistId = localStorage.getItem('userId');

        // let settingsObj = {
        //     token: userToken,
        // 	doctorId: specialistId
        // };

        // this.props.actions.getDetailsForSpecialistAvailability(settingsObj);
        // this.setState({fetchSpecialistData: true})
    }
    //   componentWillReceiveProps (nextProps) {
    //     if (nextProps.specialistDetail && this.state.fetchSpecialistData) {
    // 		this.setState({
    //             specialistDetail: nextProps.specialistDetail,
    //             fetchSpecialistData: false
    // 		}, () => {
    // 			let appointmentObj = {
    // 				...this.state.specialistDetail[0],
    // 				currenthour: this.state.currenthour,
    // 				currentmin: this.state.currentmin,
    // 				appointmentDate: this.state.appointmentDate,
    // 				userlocation: moment.tz.guess(),
    // 				avail: true
    // 			}
    //             this.props.appointmentactions.getSpecialistAvailability(appointmentObj, this.props);
    //             this.setState({appointmentDatesGetched: true})
    // 		})
    //     }
    //   }
    handleChangeStartTime = selectedOption => {
        
        let valueForEndTime = this.state.finalTimeSlotReset;
        valueForEndTime.forEach((value, i) => {
            if (value.value == selectedOption.value) {
                // 
                // return i;
                let newArray = valueForEndTime.slice(i + 1, valueForEndTime.length)
                
                this.setState({
                    finalEndTimeSlot: newArray,
                    startTime: selectedOption,
                    endTime: newArray[0],
                    finalBlockingObj: {
                        ...this.state.finalBlockingObj,
                        startDate: selectedOption.value,
                        startTime: selectedOption.value,
                    }
                }, () => {
                    
                });
            }
        });
    };
    // upper section
    handleChangeEndTime = selectedOption => {
        
        let valueForStartTime = this.state.finalTimeSlotReset;
        
        valueForStartTime.forEach((value, i) => {
            if (value.value == selectedOption.value) {
                // 
                // return i;
                let newArray = valueForStartTime.slice(0, i)
                
                this.setState({
                    finalTimeSlot: newArray,
                    endTime: selectedOption,
                    finalBlockingObj: {
                        ...this.state.finalBlockingObj,
                        // endDate: selectedOption.value,
                        endTime: selectedOption.value

                    }
                }, () => {
                    
                });
            }
        });
    };
    changeReasonForBlocking = (selectedOption) => {
        this.setState({
            reason: selectedOption,
            finalBlockingObj: {
                ...this.state.finalBlockingObj,
                reason: selectedOption.value
            }
        }, () => {
            

        })
    }
    blockingDateChanged = (selectedDate) => {
        let todayDate = selectedDate
        var convertDate = new Date(moment(todayDate).local());
        // var currenthour = moment(todayDate).local().format("HH")
        // var currentmin = moment(todayDate).local().format("mm")
        // let appointmentObj = {
        //     ...this.state.specialistDetail[0],
        //     currenthour: currenthour,
        //     currentmin: currentmin,
        //     appointmentDate: convertDate,
        //     userlocation: moment.tz.guess(),
        //     avail: true
        // }
        // staring from 1 so 
        let yearlyMonthSelected = blockingMonth[convertDate.getMonth()];
        let weeklyDaySelected = DAYS[convertDate.getDay()];
        

        let daysInMonth = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0).getDate(); 5;
        let newArrayOfDaysInMonth = DAYSOFMONTH.slice(0, daysInMonth);
        // return;
        // this.props.appointmentactions.getSpecialistAvailability(appointmentObj, this.props);
        this.setState({
            DAYSOFMONTH: newArrayOfDaysInMonth,
            daysBlocked: [],
            weekly: {
                ...this.state.weekly,
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                weeklyEndByDate: selectedDate
            },
        }, () => {
            this.setState({
                daysBlocked: [...this.state.daysBlocked, weeklyDaySelected],
                appointmentDatesGetched: true,
                dateToBlock: convertDate.getDate(),
                selectedMonthForYearlyBlock: yearlyMonthSelected,
                startDate: null,
                endDate: null,
                finalTimeSlot: blockingTimeArray,
                finalEndTimeSlot: blockingTimeArray,
                blockingDate: selectedDate,
                finalBlockingObj: {
                    ...this.state.finalBlockingObj,
                    startDate: convertDate,
                    blockingDate: selectedDate
                },
                daily: {
                    ...this.state.daily,
                    dailyEndByDate: selectedDate
                },
                weekly: {
                    ...this.state.weekly,
                    [weeklyDaySelected]: true,
                    weeklyEndByDate: selectedDate
                },
                monthly: {
                    ...this.state.monthly,
                    monthlyEndByDate: selectedDate
                },
                yearly: {
                    ...this.state.yearly,
                    yearlyEndByDate: selectedDate
                }
            })
        })

    }

    // side section

    onChangeSelectPeriod = (e) => {
        this.setState({
            selectedPeriod: e.currentTarget.value,
        })
    }
    onChangeDailyPeriodOption = (e) => {
        this.setState({
            selectedDailyPeriodOption: e.currentTarget.value,
            // daily: {
            //     dailyOccurrence: 2,
            // },
        }, () => {
            if (this.state.selectedDailyPeriodOption == 'dailyEndBy') {
                this.setState({
                    daily: {
                        ...this.state.daily,
                        dailyEndByDate: this.state.daily.dailyEndByDate
                    }
                })
            }
            if (this.state.selectedDailyPeriodOption == 'dailyNoEndDate') {
                this.setState({
                    daily: {
                        ...this.state.daily,
                        dailyOccurrence: 0,
                    }
                })
            }
            if (this.state.selectedDailyPeriodOption == 'dailyAfter') {
                this.setState({
                    daily: {
                        ...this.state.daily,
                        dailyOccurrence: 2,
                    }
                })
            }
        });
    };

    handleDailyEndByDate = (e) => {
        var todayDate = moment.utc(new Date(e));
        var convertDate = new Date(moment(todayDate).local());
        this.setState({
            daily: {
                dailyEndByDate: convertDate
            }
        });
    };

    handleDailyAfterInput = (e) => {
        this.setState({
            daily: {
                dailyOccurrence: parseInt(e.target.value)
            }
        });
    };

    // monthly section
    monthlyDateToBlock = (e) => {
        this.setState({
            dateToBlock: parseInt(e.target.value)
        });
    }

    onChangeMonthlyPeriodOption = (e) => {
        
        this.setState({
            selectedMonthlyPeriodOption: e.currentTarget.value,
            // daily: {
            //     dailyOccurrence: 2,
            // },
        }, () => {
            
            if (this.state.selectedMonthlyPeriodOption == 'monthlyEndBy') {
                this.setState({
                    monthly: {
                        ...this.state.monthly,
                        monthlyEndByDate: this.state.monthly.monthlyEndByDate
                    }
                })
            }
            if (this.state.selectedMonthlyPeriodOption == 'monthlyNoEndDate') {
                this.setState({
                    monthly: {
                        ...this.state.monthly,
                        monthlyOccurrence: 0,
                    }
                })
            }
            if (this.state.selectedMonthlyPeriodOption == 'monthlyAfter') {
                this.setState({
                    monthly: {
                        ...this.state.monthly,
                        monthlyOccurrence: 2,
                    }
                })
            }
        });
    };

    handleMonthlyAfterInput = (e) => {
        this.setState({
            monthly: {
                monthlyOccurrence: parseInt(e.target.value)
            }
        });
    };

    handleMonthlyEndByDate = (e) => {
        
        var todayDate = moment.utc(new Date(e));
        var convertDate = new Date(moment(todayDate).local());
        
        this.setState({
            monthly: {
                monthlyEndByDate: convertDate
            }
        });
    };

    // yearly blocking
    changeSelectedMonthForYearlyBlock = (selectedOption) => {
        let monthToSet = selectedOption.value - 1;
        // our timeslot is starting from 1 and the month of new Date starts from 0
        // indexing from 0;
        let newBlockingDate = this.state.blockingDate;
        if (selectedOption.value < this.state.blockingDate.getMonth() + 1) {
            newBlockingDate.setFullYear(this.state.blockingDate.getFullYear() + 1);
        }
        newBlockingDate.setMonth(monthToSet);
        this.setState({ blockingDate: newBlockingDate, selectedMonthForYearlyBlock: selectedOption })
        return;
        // newBlockingDate.setDate(monthToSet);

        // get total number of days in this month to show the accurate number of dropdown for days option
        let daysInMonth = 30;
        let newArrayOfDaysInMonth = DAYSOFMONTH.slice(0, daysInMonth);
        
        // as date slots start from index 1 instead from 0;
        this.setState({ DAYSOFMONTH: newArrayOfDaysInMonth }, () => {
            this.setState({
                dateToBlock: selectedOption.value - 1, blockingDate: newBlockingDate,
                monthly: {
                    ...this.state.monthly,
                    monthlyEndByDate: newBlockingDate
                }
            })
        });

        this.setState({
            monthToBlock: selectedOption.value - 1,
            selectedMonthForYearlyBlock: selectedOption
        })
    }

    onChangeYearlyPeriodOption = (e) => {
        
        this.setState({
            selectedYearlyPeriodOption: e.currentTarget.value,
            // daily: {
            //     dailyOccurrence: 2,
            // },
        }, () => {
            
            if (this.state.selectedYearlyPeriodOption == 'yearlyEndBy') {
                this.setState({
                    yearly: {
                        ...this.state.yearly,
                        yearlyEndByDate: this.state.yearly.yearlyEndByDate,
                    }
                })
            }
            if (this.state.selectedYearlyPeriodOption == 'yearlyNoEndDate') {
                this.setState({
                    yearly: {
                        ...this.state.yearly,
                        yearlyOccurrence: 0,
                    }
                })
            }
            if (this.state.selectedYearlyPeriodOption == 'yearlyAfter') {
                this.setState({
                    yearly: {
                        ...this.state.yearly,
                        yearlyOccurrence: 2,
                    }
                })
            }
            
        }, () => {
        });
    };

    handleYearlyEndByDate = (e) => {
        
        var todayDate = moment.utc(new Date(e));
        var convertDate = new Date(moment(todayDate).local());
        
        this.setState({
            yearly: {
                yearlyEndByDate: convertDate
            }
        });
    };

    yearlyDateToBlock = (e) => {
        this.setState({
            dateToBlock: parseInt(e.target.value)
        });
    }

    handleYearlyAfterInput = (e) => {
        this.setState({
            yearly: {
                ...this.state.yearly,
                yearlyOccurrence: parseInt(e.target.value)
            }
        });
    };

    getNextDayOfTheWeek(dayName, excludeToday = true, refDate = new Date()) {
        const dayOfWeek = DAYS
            .indexOf(dayName);
        if (dayOfWeek < 0) return;
        refDate.setHours(startHour, startMinutes, 0, 0);
        refDate.setDate(refDate.getDate() + !!excludeToday +
            (dayOfWeek + 7 - refDate.getDay() - !!excludeToday) % 7);
        
        return refDate;
    }

    // weekly recurrence 
    changeWeeklyDaysUnavailability = (e) => {
        let daySelected = e.target.name;
        if (this.state.weekly[daySelected]) {
            let index = this.state.daysBlocked.indexOf(daySelected);
            let newArr = this.state.daysBlocked;
            let daysBlocked = [...newArr.slice(0, index), ...newArr.slice(index + 1)];

            this.setState({
                daysBlocked,
                weekly: {
                    ...this.state.weekly,
                    [daySelected]: false
                }
            }, () => {
                
            })
        } else {
            this.setState({
                daysBlocked: [...this.state.daysBlocked, daySelected],
                weekly: {
                    ...this.state.weekly,
                    [daySelected]: true
                }
            }, () => {
                
            });
        }
    }

    onChangeWeeklyPeriodOption = (e) => {
        this.setState({
            selectedWeeklyPeriodOption: e.currentTarget.value,
        }, () => {
            
            if (this.state.selectedWeeklyPeriodOption == 'weeklyEndBy') {
                this.setState({
                    weekly: {
                        ...this.state.weekly,
                        weeklyEndByDate: this.state.weekly.weeklyEndByDate
                    }
                })
            }
            if (this.state.selectedWeeklyPeriodOption == 'weeklyNoEndDate') {
                this.setState({
                    weekly: {
                        ...this.state.weekly,
                        weeklyOccurrence: 0,
                    }
                })
            }
            if (this.state.selectedWeeklyPeriodOption == 'weeklyAfter') {
                this.setState({
                    weekly: {
                        ...this.state.weekly,
                        weeklyOccurrence: 2,
                    }
                })
            }
        });
    }

    handleWeeklyEndByDate = (e) => {
        var todayDate = moment.utc(new Date(e));
        var convertDate = new Date(moment(todayDate).local());
        this.setState({
            weekly: {
                weeklyEndByDate: convertDate
            }
        });
    };

    handleWeeklyAfterInput = (e) => {
        this.setState({
            weekly: {
                ...this.state.weekly,
                weeklyOccurrence: parseInt(e.target.value)
            }
        });
    };

    submitBlockAvailability = (periodToBlock) => {
        let blockingDate = this.state.blockingDate,
        startTime = this.state.startTime.value,
        endTime = this.state.endTime.value;
        let blockingEndDate = this.state.yearly.yearlyEndByDate;
        let { startHour, startMinutes, endHour, endMinutes } = generateUTCStartEndTiming({startTime, endTime});
        // let blockingDate = this.state.blockingDate;
		var userlocation = moment.tz.guess();
        var selDate = moment.utc(blockingDate);
        var selEndDate = moment.utc(blockingEndDate);
		// for react calendar
		// var selDate = udatedDate.date;
		// for fullcalendar
		

        var convertedDate = new Date(moment(selDate).local());
        var convertedEndDate = new Date(moment(selEndDate).local());
        
        let finalBlockingObj = {
            blockingDate : convertedDate,
            userlocation,
            startDate: convertedDate,
            startTime: this.state.startTime.value,
            endTime: this.state.endTime.value,
            reason: this.state.reasonForBlocking[0].label,
            endDate: convertedEndDate,
            startTiming: new Date(new Date(blockingDate.setHours(startHour)).setMinutes(startMinutes)),
            endTiming: new Date(new Date(blockingDate.setHours(endHour)).setMinutes(endMinutes)),
        };
        

        if (periodToBlock === 'daily') {
            finalBlockingObj.endDate = this.state.selectedDailyPeriodOption == 'dailyEndBy' ? finalBlockingObj.endDate : '';
            finalBlockingObj.noOfRecursion = this.state.selectedDailyPeriodOption == 'dailyAfter' ? this.state.daily.dailyOccurrence - 1 : 0;
            finalBlockingObj.recurrance = "days"
            this.props.appointmentactions.dailyBlockAvailability(finalBlockingObj, this.props);
            // this.props.closeBlockAvailability();
            // this.props.
        }
        if (periodToBlock === 'weekly') {
            if (this.state.daysBlocked.length > 0) {
                finalBlockingObj.daysBlocked = this.state.daysBlocked;
            finalBlockingObj.recurrance = "weeks"
            finalBlockingObj.endDate = this.state.selectedWeeklyPeriodOption == 'weeklyEndDate' ? finalBlockingObj.endDate : '';
                finalBlockingObj.noOfRecursion = this.state.selectedWeeklyPeriodOption == 'weeklyAfter' ? this.state.weekly.weeklyOccurrence - 1 : 0;
                
                this.props.appointmentactions.weeklyBlockAvailability(finalBlockingObj, this.props);
            } else {
                toast.info("Select At least one day to block");
            }
        }
        if (periodToBlock === 'monthly') {
            finalBlockingObj.endDate = this.state.selectedMonthlyPeriodOption == 'monthlyEndBy' ? finalBlockingObj.endDate : '';
            finalBlockingObj.recurrance = "months"
            //this.state.monthly.monthlyEndByDate;
            finalBlockingObj.noOfRecursion = this.state.selectedMonthlyPeriodOption == 'monthlyAfter' ? this.state.monthly.monthlyOccurrence - 1 : 0;
            //this.state.monthly.monthlyOccurrence;
            finalBlockingObj.dateToBlock = this.state.dateToBlock;
            

            this.props.appointmentactions.monthlyBlockAvailability(finalBlockingObj, this.props);
        }
        if (periodToBlock === 'yearly') {
            finalBlockingObj.endDate = this.state.selectedYearlyPeriodOption == 'yearlyEndBy' ? this.state.yearly.yearlyEndByDate : '';
            finalBlockingObj.recurrance = "years"
            //this.state.yearly.yearlyEndByDate;
            finalBlockingObj.noOfRecursion = this.state.selectedYearlyPeriodOption == 'yearlyAfter' ? this.state.yearly.yearlyOccurrence - 1 : 0;
            finalBlockingObj.dateToBlock = this.state.dateToBlock;
            finalBlockingObj.monthToBlock = this.state.monthToBlock;

            // let finalBlockingObj = {
            //     // blockingDate: this.state.blockingDate,
            //         // startTime: this.state.startTime.value,
            //         // endTime: this.state.endTime.value,
            //         // reason: this.state.reasonForBlocking[0].value,
            //         dateToBlock: this.state.dateToBlock,
            //         noOfRecursion: this.state.finalBlockingObj.noOfRecursion,
            //         monthToBlock: this.state.monthToBlock
            //     }
            
            // return 
            this.props.appointmentactions.yearlyBlockAvailability(finalBlockingObj, this.props)
        }
    }

    changeMonthlyBlockingDate = (selectedOption) => {
        let dateToSet = selectedOption.value;
        
        // indexing from 0;
        let newBlockingDate = this.state.blockingDate;
        if (selectedOption.value < this.state.blockingDate.getDate()) {
            newBlockingDate.setMonth(this.state.blockingDate.getMonth() + 1);
        }
        newBlockingDate.setDate(dateToSet);

        // get total number of days in this month to show the accurate number of dropdown for days option
        let daysInMonth = new Date(newBlockingDate.getFullYear(), newBlockingDate.getMonth() + 1, 0);
        let newArrayOfDaysInMonth = DAYSOFMONTH.slice(0, daysInMonth);
        
        // as date slots start from index 1 instead from 0;
        this.setState({ DAYSOFMONTH: newArrayOfDaysInMonth }, () => {
            this.setState({
                dateToBlock: dateToSet, blockingDate: newBlockingDate,
                selectedMonthForYearlyBlock: blockingMonth[newBlockingDate.getMonth()],
                monthly: {
                    ...this.state.monthly,
                    monthlyEndByDate: newBlockingDate,

                },
                yearly: {
                    ...this.state.yearly,
                    yearlyEndByDate: newBlockingDate,

                }
            })
        });
    }

    render() {
        
        return (
            <Modal className="blockAvailability" show={this.props.openBlockAvailability} size="lg" onHide={this.props.closeBlockAvailability}>
                <Modal.Header closeButton>
                    {/* <ModalClose onClick={} /> */}
                    <Modal.Title align="left">
                        <h4>Recurrence <span><i class="fa fa-refresh recur ml-20"></i></span></h4>
                        {/* <div className="col-xs-2 col-sm-2 col-md-1 col-lg-1"> */}
                        <div className="tooltip-custom fadeEffect posabr00 pull-right subRight helpsvg mobileposavr00" data-title="Enter blocks of time where you will be unavailable and select the appropriate reason.">
                            {/* <span>
                        <SVGICONS.Helppic />
                    </span>	 */}
                        </div>
                        {/* </div> */}
                    </Modal.Title>
                    {/* <img src={require('../../images/images/logo.svg')} alt="" /> */}
                </Modal.Header>
                <Modal.Body>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-2" id="inputGroupPrepend">
                                <label className="label">Date</label>
                            </div>
                            <div className="col-lg-7">
                                <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                    <div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
                                        <div className="input-group-addon"><i className="fa ">
                                            <img src={require('../../images/img/date_input_icon.svg')} /></i></div>
                                        <DatePicker
                                            name="blockingdate"
                                            dateFormat="dd-MM-yyyy"
                                            selected={this.state.blockingDate}
                                            onChange={this.blockingDateChanged}
                                            placeholderText="Date"
                                            // maxDate={moment().add(2, 'year')}
                                            minDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown={true}
                                            shouldCloseOnSelect={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="text-center"></div>
                            </div>
                        </div>
                    </div>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-2" id="inputGroupPrepend">
                                <label className="label">Time</label>
                            </div>
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                <div className="boxMrgB">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <SVGICONS.ScheduleInputSvg />
                                        </span>
                                        <Select
                                            // styles={customStyles}
                                            value={this.state.startTime}
                                            onChange={this.handleChangeStartTime}
                                            options={this.state.finalTimeSlot}
                                            defaultValue={this.state.startTime}
                                        />
                                    </div>
                                    <div>
                                        <span className="help-block">{this.props.friday && this.props.fridayEveningSchedule.message}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                <div className="boxMrgB">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <SVGICONS.ScheduleInputSvg />
                                        </span>
                                        <Select
                                            // styles={customStyles}
                                            value={this.state.endTime}
                                            onChange={this.handleChangeEndTime}
                                            options={this.state.finalEndTimeSlot}
                                            defaultValue={this.state.endTime}
                                        />
                                        {/* <small>dsfsdkf;ls</small> */}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <h6>Recurrence Pattern</h6>

                    <div className="row">
                        <div className="col-sm-4">
                            <div className="borderR">
                                <div className="radio radio-primary radio-period">
                                    <input type="radio" checked={this.state.selectedPeriod == 'daily'} name="recurrence" id="daily" value="daily" onChange={this.onChangeSelectPeriod} /* checked={this.state.recurrence? this.state.recurrencevalue === 'Male' : ''} */ />
                                    <label htmlFor="daily"> Daily </label>
                                </div>
                                <div className="radio radio-primary radio-period">
                                    <input type="radio" checked={this.state.selectedPeriod == 'weekly'} name="recurrence" id="weekly" value="weekly" onChange={this.onChangeSelectPeriod} /* checked={this.state.recurrence? this.state.recurrencevalue === 'Male' : ''} */ />
                                    <label htmlFor="weekly"> Weekly </label>
                                </div>
                                <div className="radio radio-primary radio-period">
                                    <input type="radio" checked={this.state.selectedPeriod == 'monthly'} name="recurrence" id="monthly" value="monthly" onChange={this.onChangeSelectPeriod}/* checked={this.state.recurrence? this.state.recurrencevalue === 'Male' : ''} */ />
                                    <label htmlFor="monthly"> Monthly </label>
                                </div>
                                <div className="radio radio-primary radio-period">
                                    <input type="radio" checked={this.state.selectedPeriod == 'yearly'} name="recurrence" id="yearly" value="yearly" onChange={this.onChangeSelectPeriod}/* checked={this.state.recurrence? this.state.recurrencevalue === 'Male' : ''} */ />
                                    <label htmlFor="yearly"> Yearly </label>
                                </div>
                            </div>
                        </div>
                        {this.state.selectedPeriod == 'daily' ?
                            <div className="col-sm-8">
                                <div className="loginInput1">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            {/* <div className="boxMrgB boxMrgT"> */}
                                            <div className="radio radio-primary radio-period">
                                                <input type="radio" checked={this.state.selectedDailyPeriodOption == 'dailyEndBy'} name="daily" id="dailyEndBy" onChange={this.onChangeDailyPeriodOption} value="dailyEndBy" /* checked={this.state.enddate ? this.state.enddate.value === 'Male' : ''} */ />
                                                <label htmlFor="dailyEndBy"> End By </label>
                                            </div>
                                            {/* </div> */}
                                            {/* <div>
                                            <input type="radio" /><label>End by</label>
                                        </div> */}
                                        </div>
                                        <div className="col-sm-8">
                                            <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                                <div className="input-group date inputBg dateInputfild endby" style={{ color: '#4d4d4d !important' }}>
                                                    <div className="input-group-addon"><i className="fa ">
                                                        <img src={require('../../images/img/date_input_icon.svg')} /></i></div>
                                                    {/* <DatePicker
                                                name="searchdate"
                                                dateFormat="dd-MM-yyyy"
                                                selected={this.state.daily.dailyEndByDate}
                                                onChange={this.handleDailyEndByDate}
                                                placeholderText="Date"
                                                // maxDate={moment().add(1, 'year')}
                                                minDate={this.state.blockingDate}
                                                showMonthDropdown
                                                showYearDropdown
                                                shouldCloseOnSelect={true}
                                                disabled={this.state.selectedDailyPeriodOption !== 'dailyEndBy'}
                                            /> */}
                                                    <DatePicker
                                                        name="searchdate"
                                                        dateFormat="dd-MM-yyyy"
                                                        selected={this.state.yearly.yearlyEndByDate}
                                                        onChange={this.handleYearlyEndByDate}
                                                        placeholderText="Date"
                                                        // maxDate={moment().add(1, 'year')}
                                                        minDate={this.state.blockingDate}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        shouldCloseOnSelect={true}
                                                        disabled={this.state.selectedDailyPeriodOption !== 'dailyEndBy'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="loginInput1">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            {/* <div className="boxMrgB boxMrgT"> */}
                                            <div className="radio radio-primary radio-period">
                                                <input type="radio" checked={this.state.selectedDailyPeriodOption == 'dailyAfter'} name="daily" id="dailyAfter" onChange={this.onChangeDailyPeriodOption} value="dailyAfter" /* checked={this.state.enddate ? this.state.enddate.value === 'Male' : ''} */ />
                                                <label htmlFor="dailyAfter"> After </label>
                                            </div>
                                            {/* </div> */}
                                            {/* <div>
                                            <input type="radio" /><label>After</label>
                                        </div> */}
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
                                                {/* <div className="input-group inputBg clock"> */}
                                                <input style={{ width: '100%' }} disabled={this.state.selectedDailyPeriodOption !== 'dailyAfter'} type="number" value={this.state.daily.dailyOccurrence} onChange={this.handleDailyAfterInput} defaultValue={1} />
                                                {/* </div> */}
                                            </div>
                                        </div>
                                        <div className="col-sm-4" className="occurrenceSpan"><label> Occurrences</label> </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="radio radio-primary radio-period">
                                            <input type="radio" checked={this.state.selectedDailyPeriodOption == 'dailyNoEndDate'} name="daily" id="dailyNoEndDate" onChange={this.onChangeDailyPeriodOption} value="dailyNoEndDate" /* checked={this.state.enddate ? this.state.enddate.value === 'Male' : ''} */ />
                                            <label htmlFor="dailyNoEndDate"> No End Date </label>
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            this.state.selectedPeriod == 'weekly' ?
                                <div className="col-sm-8">
                                    <div className="loginInput1">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <span>Reoccur Every</span>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t">
                                                {/* <form className="checkcustom"> */}
                                                <div className="form-group checkcustom weekDays">
                                                    <div className="checkbox checkbox-primary checkboxInline">
                                                        <div className="row m-b-5">
                                                            <div className="col-sm-4">
                                                                <input type="checkbox" onChange={this.changeWeeklyDaysUnavailability} /*defaultValue={this.props.saturday.value} */ name="sunday" id="Sunday"
                                                                    checked={this.state.weekly.sunday}
                                                         /* checked={this.props.Sunday && this.props.Sunday.value == true ? true : ''} */ />
                                                                <label htmlFor="Sunday" className="startReview">
                                                                    <span className="weeklyPeriod">Sunday</span>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <input type="checkbox" onChange={this.changeWeeklyDaysUnavailability} /*defaultValue={this.props.saturday.value} */ name="monday" id="Monday"
                                                                    checked={this.state.weekly.monday}
                                                        /* checked={this.props.Monday && this.props.Monday.value == true ? true : ''} */ />
                                                                <label htmlFor="Monday" className="startReview">
                                                                    <span className="weeklyPeriod">Monday</span>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <input type="checkbox" onChange={this.changeWeeklyDaysUnavailability} /*defaultValue={this.props.saturday.value} */ name="tuesday" id="Tuesday" /* checked={this.props.Tuesday && this.props.Tuesday.value == true ? true : ''} */
                                                                    checked={this.state.weekly.tuesday}
                                                                />
                                                                <label htmlFor="Tuesday" className="startReview">
                                                                    <span className="weeklyPeriod">Tuesday</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="row m-b-5">
                                                            <div className="col-sm-6">
                                                                <input type="checkbox" onChange={this.changeWeeklyDaysUnavailability}
                                                                    checked={this.state.weekly.wednesday}
                                                        /*defaultValue={this.props.saturday.value} */ name="wednesday" id="Wednesday" /* checked={this.props.Wednesday && this.props.Wednesday.value == true ? true : ''} */ />
                                                                <label htmlFor="Wednesday" className="startReview">
                                                                    <span className="weeklyPeriod">Wednesday</span>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <input type="checkbox" onChange={this.changeWeeklyDaysUnavailability}
                                                                    checked={this.state.weekly.thursday}
                                                        /*defaultValue={this.props.saturday.value} */ name="thursday" id="Thursday" /* checked={this.props.Thursday && this.props.Thursday.value == true ? true : ''} */ />
                                                                <label htmlFor="Thursday" className="startReview">
                                                                    <span className="weeklyPeriod">Thursday</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <input type="checkbox" onChange={this.changeWeeklyDaysUnavailability}
                                                                    checked={this.state.weekly.friday}
                                                        /*defaultValue={this.props.saturday.value} */ name="friday" id="Friday" /* checked={this.props.Friday && this.props.Friday.value == true ? true : ''} */ />
                                                                <label htmlFor="Friday" className="startReview">
                                                                    <span className="weeklyPeriod">Friday</span>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <input type="checkbox" onChange={this.changeWeeklyDaysUnavailability}
                                                                    checked={this.state.weekly.saturday}
                                                        /*defaultValue={this.props.saturday.value} */ name="saturday" id="saturday" /* checked={this.props.saturday && this.props.saturday.value == true ? true : ''} */ />
                                                                <label htmlFor="saturday" className="startReview">
                                                                    <span className="weeklyPeriod">Saturday</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* </form> */}
                                            <div className="col-sm-4">
                                                <div className="radio radio-primary radio-period">
                                                    <input type="radio" name="weeklyEndDate" id="weeklyEndDate" onChange={this.onChangeWeeklyPeriodOption} value="weeklyEndDate" checked={this.state.selectedWeeklyPeriodOption == 'weeklyEndDate'} />
                                                    <label htmlFor="weeklyEndDate"> End By </label>
                                                </div>
                                            </div>
                                            <div className="col-sm-8">
                            <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">

                                                <div className="input-group date inputBg dateInputfild endby" style={{ color: '#4d4d4d !important' }}>
                                                    <div className="input-group-addon"><i className="fa ">
                                                        <img src={require('../../images/img/date_input_icon.svg')} /></i></div>
                                                    {/* <DatePicker
                                                name="searchdate"
                                                dateFormat="dd-MM-yyyy"
                                                selected={this.state.weekly.weeklyEndByDate}
                                                onChange={this.handleWeeklyEndByDate}
                                                placeholderText="Date"
                                                // maxDate={moment().add(1, 'year')}
                                                minDate={this.state.weekly.weeklyEndByDate}
                                                showMonthDropdown
                                                showYearDropdown
                                                shouldCloseOnSelect={true}
                                                disabled={this.state.selectedWeeklyPeriodOption !== 'weeklyEndDate'}
                                            /> */}
                                                    <DatePicker
                                                        name="searchdate"
                                                        dateFormat="dd-MM-yyyy"
                                                        selected={this.state.yearly.yearlyEndByDate}
                                                        onChange={this.handleYearlyEndByDate}
                                                        placeholderText="Date"
                                                        // maxDate={moment().add(1, 'year')}
                                                        minDate={this.state.blockingDate}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        shouldCloseOnSelect={true}
                                                        disabled={this.state.selectedWeeklyPeriodOption !== 'weeklyEndDate'}
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="loginInput1">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="radio radio-primary radio-period">
                                                    <input type="radio" name="weeklyAfter" id="weeklyAfter" onChange={this.onChangeWeeklyPeriodOption} value="weeklyAfter" checked={this.state.selectedWeeklyPeriodOption == 'weeklyAfter'} />
                                                    <label htmlFor="weeklyAfter"> After </label>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
                                                    {/* <div className="input-group inputBg clock"> */}
                                                    <input style={{ width: '100%' }} type="number" disabled={this.state.selectedWeeklyPeriodOption !== 'weeklyAfter'} value={this.state.weekly.weeklyOccurrence} onChange={this.handleWeeklyAfterInput} />
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                            <div className="col-sm-4" className="occurrenceSpan"><label> Occurences </label></div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="radio radio-primary radio-period">
                                                <input type="radio" name="weeklyNoEndDate" id="weeklyNoEndDate" onChange={this.onChangeWeeklyPeriodOption} value="weeklyNoEndDate" checked={this.state.selectedWeeklyPeriodOption == 'weeklyNoEndDate'} />
                                                <label htmlFor="weeklyNoEndDate"> No End Date </label>
                                            </div>
                                        </div>
                                    </div>
                                </div> :
                                this.state.selectedPeriod == 'monthly' ?
                                    <div className="col-sm-8">
                                        <p>monthly</p>
                                        <div className="loginInput1">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <label style={{ display: 'flex', "align-items": 'center', marginBottom: '15px', paddingLeft: '14px' }}>
                                                        <span style={{ marginRight: '10px' }}>On</span>
                                                        <div className="input-group inputBg yearlyMonth" /* style={{ color: '#4d4d4d !important', width: '20%' }} */>
                                                            {/* <Select
                                                    // styles={customStyles}
                                                    value={this.state.DAYSOFMONTH[this.state.dateToBlock]}
                                                    onChange={this.changeMonthlyBlockingDate}
                                                    options={this.state.DAYSOFMONTH}
                                                    defaultValue={this.state.DAYSOFMONTH[this.state.dateToBlock]}
                                                /> */}
                                                            <Select
                                                                // styles={customStyles}
                                                                value={this.state.DAYSOFMONTH[this.state.dateToBlock - 1]}
                                                                onChange={this.changeMonthlyBlockingDate}
                                                                options={this.state.DAYSOFMONTH}
                                                                defaultValue={this.state.DAYSOFMONTH[this.state.dateToBlock]}
                                                            />
                                                            {/* <input style={{width: '100%'}} type="number" onChange={this.yearlyDateToBlock} value={this.state.dateToBlock} /> */}
                                                        </div>
                                                        {/* <div className="input-group inputBg" style={{ color: '#4d4d4d !important', width: '20%' }}>
                                                <input style={{width: '100%'}} type="number" value={this.state.dateToBlock} onChange={this.monthlyDateToBlock}  min="1" max="31"/>
                                            </div>  */}
                                                        <span style={{ marginLeft: '10px' }}>of every month</span>
                                                    </label>
                                                </div>
                                                <div className="col-sm-4">
                                                    {/* <div className="boxMrgB boxMrgT"> */}
                                                    <div className="radio radio-primary radio-period">
                                                        <input type="radio" name="monthly" id="monthlyEndBy" onChange={this.onChangeMonthlyPeriodOption} value="monthlyEndBy" checked={this.state.selectedMonthlyPeriodOption == 'monthlyEndBy'} />
                                                        <label htmlFor="monthlyEndBy"> End By </label>
                                                    </div>
                                                    {/* </div> */}
                                                    {/* <div>
                                            <input type="radio" /><label>End by</label>
                                        </div> */}
                                                </div>
                                                <div className="col-sm-8">
                            <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">

                                                    <div className="input-group date inputBg dateInputfild endby" style={{ color: '#4d4d4d !important' }}>
                                                        <div className="input-group-addon"><i className="fa ">
                                                            <img src={require('../../images/img/date_input_icon.svg')} /></i></div>
                                                        <DatePicker
                                                            name="searchdate"
                                                            dateFormat="dd-MM-yyyy"
                                                            selected={this.state.yearly.yearlyEndByDate}
                                                            onChange={this.handleYearlyEndByDate}
                                                            placeholderText="Date"
                                                            // maxDate={moment().add(1, 'year')}
                                                            minDate={this.state.blockingDate}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            shouldCloseOnSelect={true}
                                                            disabled={this.state.selectedMonthlyPeriodOption !== 'monthlyEndBy'}
                                                        />
                                                        {/* <DatePicker
                                                name="searchdate"
                                                dateFormat="dd-MM-yyyy"
                                                selected={this.state.monthly.monthlyEndByDate}
                                                onChange={this.handleMonthlyEndByDate}
                                                placeholderText="Date"
                                                // maxDate={moment().add(1, 'year')}
                                                minDate={this.state.blockingDate}
                                                showMonthDropdown
                                                showYearDropdown
                                                shouldCloseOnSelect={true}
                                                disabled={this.state.selectedMonthlyPeriodOption !== 'monthlyEndBy'}
                                            /> */}
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="loginInput1">
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    {/* <div className="boxMrgB boxMrgT"> */}
                                                    <div className="radio radio-primary radio-period">
                                                        <input type="radio" name="monthly" id="monthlyAfter" onChange={this.onChangeMonthlyPeriodOption} value="monthlyAfter" checked={this.state.selectedMonthlyPeriodOption == 'monthlyAfter'} />
                                                        <label htmlFor="monthlyAfter"> After </label>
                                                    </div>
                                                    {/* </div> */}
                                                    {/* <div>
                                            <input type="radio" /><label>After</label>
                                        </div> */}
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
                                                        {/* <div className="input-group inputBg clock"> */}
                                                        <input style={{ width: '100%' }} type="number" disabled={this.state.selectedMonthlyPeriodOption !== 'monthlyAfter'} value={this.state.monthly.monthlyOccurrence} onChange={this.handleMonthlyAfterInput} />
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                                <div className="col-sm-4"><span className="occurrenceSpan"><label> Occurences </label></span></div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="radio radio-primary radio-period">
                                                    <input type="radio" name="monthly" id="monthlyNoEndDate" onChange={this.onChangeMonthlyPeriodOption} value="monthlyNoEndDate" checked={this.state.selectedMonthlyPeriodOption == 'monthlyNoEndDate'} />
                                                    <label htmlFor="monthlyNoEndDate"> No End Date </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    this.state.selectedPeriod == 'yearly' ?
                                        <div className="col-sm-8">
                                            <div className="loginInput1">
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <label style={{ display: 'flex', "align-items": 'center', marginBottom: '20px', paddingLeft: '14px' }}>
                                                            <span style={{ marginRight: '10px' }}>On</span>
                                                            <div className="input-group inputBg yearlyMonth" /* style={{ color: '#4d4d4d !important', width: '20%' }} */>
                                                                <Select
                                                                    // styles={customStyles}
                                                                    value={this.state.DAYSOFMONTH[this.state.dateToBlock - 1]}
                                                                    onChange={this.changeMonthlyBlockingDate}
                                                                    options={this.state.DAYSOFMONTH}
                                                                    defaultValue={this.state.DAYSOFMONTH[this.state.dateToBlock]}
                                                                />
                                                                {/* <input style={{width: '100%'}} type="number" onChange={this.yearlyDateToBlock} value={this.state.dateToBlock} /> */}
                                                            </div>
                                                        </label>
                                                        <label style={{ display: 'flex', "align-items": 'center', marginBottom: '20px', paddingLeft: '14px' }}>
                                                            <span style={{ marginRight: '10px' }}>Of</span>
                                                            <div className="input-group inputBg yearlyMonth">
                                                                <span className="input-group-addon yearlyMonthIcon">
                                                                    {/* <SVGICONS.ScheduleInputSvg /> */}
                                                                    <i className="fa "><img src={require('../../images/img/date_input_icon.svg')} /></i>

                                                                </span>
                                                                <Select
                                                                    // styles={customStyles}
                                                                    value={this.state.selectedMonthForYearlyBlock}
                                                                    onChange={this.changeSelectedMonthForYearlyBlock}
                                                                    options={blockingMonth}
                                                                    defaultValue={this.state.selectedMonthForYearlyBlock}
                                                                />
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        {/* <div className="boxMrgB boxMrgT"> */}
                                                        <div className="radio radio-primary radio-period">
                                                            <input type="radio" name="yearly" id="yearlyEndBy" onChange={this.onChangeYearlyPeriodOption} value="yearlyEndBy" checked={this.state.selectedYearlyPeriodOption == 'yearlyEndBy'} />
                                                            <label htmlFor="yearlyEndBy"> End By </label>
                                                        </div>
                                                        {/* </div> */}
                                                        {/* <div>
                                            <input type="radio" /><label>End by</label>
                                        </div> */}
                                                    </div>
                                                    <div className="col-sm-8">
                            <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                                    
                                                        <div className="input-group date inputBg dateInputfild endby" style={{ color: '#4d4d4d !important' }}>
                                                            <div className="input-group-addon"><i className="fa ">
                                                                <img src={require('../../images/img/date_input_icon.svg')} /></i></div>
                                                            <DatePicker
                                                                name="searchdate"
                                                                dateFormat="dd-MM-yyyy"
                                                                selected={this.state.yearly.yearlyEndByDate}
                                                                onChange={this.handleYearlyEndByDate}
                                                                placeholderText="Date"
                                                                // maxDate={moment().add(1, 'year')}
                                                                minDate={this.state.blockingDate}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                shouldCloseOnSelect={true}
                                                                disabled={this.state.selectedYearlyPeriodOption !== 'yearlyEndBy'}
                                                            />
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="loginInput1">
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        {/* <div className="boxMrgB boxMrgT"> */}
                                                        <div className="radio radio-primary radio-period">
                                                            <input type="radio" name="yearly" id="yearlyAfter" onChange={this.onChangeYearlyPeriodOption} value="yearlyAfter" checked={this.state.selectedYearlyPeriodOption == 'yearlyAfter'} />
                                                            <label htmlFor="yearlyAfter"> After </label>
                                                        </div>
                                                        {/* </div> */}
                                                        {/* <div>
                                            <input type="radio" /><label>After</label>
                                        </div> */}
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <div className="input-group inputBg" style={{ color: '#4d4d4d !important' }}>
                                                            {/* <div className="input-group inputBg clock"> */}
                                                            <input style={{ width: '100%' }} type="number" disabled={this.state.selectedYearlyPeriodOption !== 'yearlyAfter'} value={this.state.yearly.yearlyOccurrence} onChange={this.handleYearlyAfterInput} />
                                                            {/* </div> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-4" className="occurrenceSpan"><label> Occurences </label></div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="radio radio-primary radio-period">
                                                        <input type="radio" name="yearly" id="noenddate" onChange={this.onChangeYearlyPeriodOption} value="yearlyNoEndDate" checked={this.state.selectedYearlyPeriodOption == 'yearlyNoEndDate'} />
                                                        <label htmlFor="noenddate"> No End Date </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : <p>No Available</p>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="btnSubmit text-center" style={{ margin: "auto" }}>
                        <button className="btn btn-primary" disabled={(this.state.selectedPeriod == 'weekly' && this.state.daysBlocked.length == 0) || (this.state.selectedPeriod == 'monthly' && (isNaN(this.state.dateToBlock) || this.state.dateToBlock < 1)) || (this.state.selectedPeriod == 'yearly' && (isNaN(this.state.dateToBlock) || this.state.dateToBlock < 1))} onClick={() => this.submitBlockAvailability(this.state.selectedPeriod)}>Ok</button>&nbsp;
                        <button className="btn btn-primary" onClick={this.props.closeBlockAvailability}>Cancel</button>
                    </div>
                </Modal.Footer>
            </Modal >
        );
    }
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
    return {
        specialistDetail: state.specialist.specialistDetail,
        appointments: state.specialist.appointments,
        specialistAvailability: state.appointment.specialistAvailability,
    };
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(specialistActions, dispatch),
        appointmentactions: bindActionCreators(appointmentActions, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(BlockD);